<template>
  <v-form v-model="form_valido" ref="form" lazy-validation>
    <z-dialogo ref="dialogo" titulo="Conta Bancária" :dividers="true" largura="800px" persistent @fechar="onFechar">
      <template #conteudo>
        <v-row dense>
          <v-col cols="6">
            <v-autocomplete 
              v-model="conta.banco_id" 
              label="Banco" 
              filled 
              dense
              :rules="[v => !!v || 'Campo obrigatório']" 
              :items="$store.state.listas.bancos"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <z-text-field 
              label="Agência" 
              v-model="conta.agencia" 
              filled 
              dense
              :rules="[v => !!v || 'Campo obrigatório']"
            ></z-text-field>
          </v-col>
          <v-col cols="3">
            <z-text-field 
              label="Conta" 
              v-model="conta.numero_conta" 
              filled 
              dense
              :rules="[v => !!v || 'Campo obrigatório']"
            ></z-text-field>
          </v-col>
          <v-col cols="12">
            <z-text-field 
              label="Titular" 
              v-model="conta.titular" 
              filled 
              dense
              :rules="[v => !!v || 'Campo obrigatório']"
            ></z-text-field>
          </v-col>
          <!-- <v-col cols="4">
            <v-select
              :items="$globals.TIPO_CONTA_BANCARIA"
              label="Tipo de Conta"
              v-model="conta.tipo_conta"
              filled
              dense
            ></v-select>
          </v-col> -->
        </v-row>
      </template>
      
      <template #actions_right>
        <v-btn text @click="$refs.dialogo.fechar()" :disabled="salvando">
          Cancelar
        </v-btn>
        <v-btn depressed color="primary" @click="salvar" :disabled="!form_valido" :loading="salvando">
          Salvar
        </v-btn>
      </template>
    </z-dialogo>


  </v-form>
</template>

<script setup>
import { ref, computed, getCurrentInstance, onMounted, inject } from 'vue';
import queryBuilder from '@/app/helpers/QueryBuilder';

const { proxy } = getCurrentInstance();
const $store = proxy.$store;

const dialogo = ref(null);
const form = ref(null);
const form_valido = ref(true);
const salvando = ref(false);
const excluindo = ref(false);

const $notificacao = inject('notificacao');

onMounted(async () => {
  // $store.dispatch('listas/bancos');

  await $store.dispatch("listas/fetchListas", [
      queryBuilder()
        .from("Banco")
        .selectraw("id as value, concat(codigo, ' - ', descricao) as text")
        .orderBy("codigo")
        .build()
  ]);
});

const conta = computed(() => {
  return $store.state.fornecedores.conta;
});

const fornecedor = computed(() => {
  return $store.state.fornecedores.fornecedor;
});

function abrir() {
  dialogo.value.abrir();
}

function fechar() {
  onFechar();
  dialogo.value.fechar();
}

function onFechar() {
  $store.commit('fornecedores/LIMPAR_CONTA');
  form.value.resetValidation();
}

async function salvar() {

  salvando.value = true;
  // console.log("SALVAR CONTA", conta.value);
  try {
    if (conta.value.id) {
      await $store.dispatch('fornecedores/atualizarConta', conta.value);
    } else {
      conta.value.fornecedor_id = fornecedor.value.id;
      await $store.dispatch('fornecedores/salvarConta', conta.value);
    }
    $notificacao.notificar("Conta salva com sucesso!");
    // await $store.dispatch('fornecedores/listarContas', conta.value.fornecedor_id);
  } catch (error) {
    $notificacao.error("Houve um erro ao salvar a conta", error);
    throw error;
  } finally {
    salvando.value = false;
    dialogo.value.fechar();
  }
}

defineExpose({
  abrir,
  fechar,
});

</script>

<style lang="scss" scoped>

</style>